import { FuelCheckbox, FuelGridContainer, FuelGridItem } from '@frete.com/fuel-react';
import { DESTINY_WIDTH_BREAKPOINT, LOCALIZATION_WIDTH_BREAKPOINT } from 'constants/styled.contants';
import { useAppContext } from 'hooks/useAppContext';
import { useFilteredData } from 'hooks/useFilteredData';
import { useSelectAllTruckers } from 'hooks/useSelectAllTruckers';
import React, { FC } from 'react';
import * as Styled from './styled';

const ListHeader: FC = () => {
  const {
    state: {
      shareFreights: { truckers },
    },
  } = useAppContext();
  const { filteredDataSuggested } = useFilteredData();
  const { selectAllTruckers, unselectAllTruckers } = useSelectAllTruckers();

  const hasCheckedTruckers = truckers.length > 0;
  const showDestiny = window.innerWidth > DESTINY_WIDTH_BREAKPOINT;
  const showLocalization = window.innerWidth > LOCALIZATION_WIDTH_BREAKPOINT;

  function getGridCollum() {
    if (!showDestiny && showLocalization) {
      return 3;
    }
    if (!showLocalization) {
      return 4;
    }
    return 2;
  }

  return (
    <Styled.Header data-testid="list-header" $hasCheckedTruckers={hasCheckedTruckers}>
      <FuelGridContainer spacingBottom={16} spacingTop={24}>
        <FuelGridItem lg={getGridCollum()}>
          <FuelCheckbox
            data-testid="select-all-checkbox"
            checked={hasCheckedTruckers}
            variant={filteredDataSuggested?.length === truckers.length ? 'check' : 'mixed'}
            onInput={(e) => {
              const { checked } = e.target as HTMLFuelCheckboxElement;
              checked ? selectAllTruckers() : unselectAllTruckers();
            }}
          />
        </FuelGridItem>

        <FuelGridItem lg={showDestiny ? 5 : 6}>Nome</FuelGridItem>

        {showLocalization && <FuelGridItem lg={3}>Localização</FuelGridItem>}

        {showDestiny && <FuelGridItem lg={2}>Destino</FuelGridItem>}
      </FuelGridContainer>
    </Styled.Header>
  );
};

export default ListHeader;
